import { render, staticRenderFns } from "./sDataPersonView.vue?vue&type=template&id=48a295ca&scoped=true"
import script from "./sDataPersonView.vue?vue&type=script&lang=js"
export * from "./sDataPersonView.vue?vue&type=script&lang=js"
import style0 from "./sDataPersonView.vue?vue&type=style&index=0&id=48a295ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a295ca",
  null
  
)

export default component.exports